export default {
    // "home": {
    //     "title": "Administração Geral"
    // },
    "modules": {
        "titles": "Módulos",
        "title": "Módulo",
        "list": {
            "order": "@:modules.model.order",
            "name": "@:modules.model.name",
            "guest": "@:modules.model.guest",
            "status": "@:modules.model.status",
            "backoffice": "Gestão",
        },
        "model": {
            "code": "Código",
            "name": "Nome",
            "description": "Descrição",
            "keywords": "Palavras-Chave",
            "order": "Ordem",
            "home": "Página Inicial",
            "backoffice": "Módulo de Gestão",
            "guest": "Acesso",
            "status": "Ativo",
            "url": "Url",
            "icon": "Icon",
            "image": "Imagem",
            "theme_color": "Côr do Tema",
        },
        "help": {
            "name": "Nome do Módulo.",
            "code": "Preencher caso corresponda a um módulo da plataforma, caso contrário, deve definir o campo URL. Apenas são permitidos: caracteres minúsculos não especiais, números, '-' e '_'",
            "order": "Ordem que o módulo aparece no dashboard.",
            "home": "Este módulo aparece na listagem dos módulos na página inicial.",
            "backoffice": "Corresponde a um módulo de gestão.",
            "guest": "Tipo de acesso ao módulo.",
            "icon": "Icon do módulo a apresentar na listagem dos módulos.",
            "theme_color": "Indica a côr para os browsers utilizarem para personalizar a exibição da página ou da interface do utilizador.",
            "url": "Definir o endereço HTTP para um link externo. Se este campo for definido, o campo Código deve estar vazio.",
            "description": "A descrição corresponde ao título SEO e, é ele que vai ser lido pelo Google (na hora que este examina todos os sites da internet) e exibido na página de resultados. Respeitar a quantidade mínima (35) e máxima (65) de caracteres, contando espaços e símbolos, no entanto, o tamanho do título SEO para mobile é de cerca de 55 caracteres. Como queremos garantir que tanto o utilizador no desktop quanto em dispositivos móveis tenham acesso integral ao seu conteúdo, melhor ficar no máximo com 55 caracteres.",
            "keywords": "Escolha a palavra-chave certa. As palavras-chave ou keywords são elementos fundamentais de SEO. São os termos utilizados pelos utilizadores nas pesquisas – o que eles digitam ou comandam por voz ao Google.",
            "public": "Público",
            "private": "Privado",
        },
    },
    "users": {
        "titles": "Utilizadores",
        "title": "Utilizador",
        "model": {
            "name": "Nome",
            "email": "E-mail",
            "phone": "Contato",
            "nif": "NIF",
            "roles": "Perfil",
            "active": "Ativo",
            "password": "Password",
            "password_confirmation": "Confirmar Password",
        },
        "msg":{
            "confirm": {
                "delete-item": "Deseja remover o utilizador <u>{name}</u>?",
            }
        },
    },
    "roles": {
        "titles": "Perfis",
        "title": "Perfil"
    },
    "ogc_remote_services": {
        "titles": "Serviços OGC",
        "title": "Serviço OGC",
        "import_resources": "Importar camadas",
        "list": {
            "url": "@:ogc_remote_services.model.url",
            "title": "@:ogc_remote_services.model.title",
            "type": "@:ogc_remote_services.model.type",
        },
        "model": {
            "url": "URL",
            "title": "Título",
            "description": "Descrição",
            "abstract": "Resumo",
            "keywords": "Palavras-Chave",
            "type": "Tipo",
            "use_proxy": "Utilizar Proxy",
            "is_private": "Privado",
            "username": "Utilizador",
            "password": "Password",
        },
        "resources": {
            "title": "Camadas do Serviço",
            "list": {
                "id": "Name",
                "title": "Título",
                "abstract": "Descrição",
            },
            "actions": {
                "save": {
                    "title": "Importar Camadas",
                },
                "import": {
                    "title": "Importar Novas Camadas", //Import Service Resources
                },
                "unlink": {
                    "title": "Despublicar Camada",
                    "confirm": "Tem a certeza que pretende despublicar a camada <u>{name}</u>?",
                },
            },
            "no_resources": "Ainda não foram importadas camadas.", //No resources have been imported yet.
            "all_resources_imported": "Já foram importadas todas os camadas",
            "resources_to_imported": "{num} camadas que podem ser importadas",
        },
        "msg": {
            "confirm": {
                "reload": "Pretende efetuar o reload do serviço <u>{name}</u>?"
            }
        },
        "help": {
            "use_proxy": "Com o valor <b>\"Sim\"</b>, é possível publicar temas do servidor OGC sem que o mesmo esteja publicado para a internet, e desta forma, \"esconde\" o endereço no <b>frontend</b> da aplicação.",
            "is_private": "Com o valor <b>\"Sim\"</b>, os temas apenas estão acessíveis para utilizadores autenticados.",
        },
    },
    "database_notifications": {
        "titles": "Notificações Enviadas",
        "title": "Notificação",
        "model": {
            "channel": "Tipo",
            "module": "Módulo",
            "subject": "Assunto",
            "message": "Mensagem",
            "to": "Destinatários",
            "cc": "Destinatários em CC",
            "bcc": "Destinatários em BCC",
            "created_at": "Data",
        },
        "list": {
            "channel": "@:database_notifications.model.channel",
            "module": "@:database_notifications.model.module",
            "subject": "@:database_notifications.model.subject",
            "message": "@:database_notifications.model.message",
            "to": "@:database_notifications.model.to",
            "created_at": "@:database_notifications.model.created_at",
        },
        "search": {
            "channel": "@:database_notifications.model.channel",
            "module": "@:database_notifications.model.module",
            "recipients": "Destinatários",
            "content": "Conteúdo",
            "created_at": "@:database_notifications.model.created_at",
        }
    }
}

